import React, { useState } from "react";
import {
  IonButton,
  IonButtons,
  IonCheckbox,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonModal,
  IonTitle,
  IonToolbar,
} from "@ionic/react";

import { useDispatch, useSelector } from "react-redux";
import {
  setFilterByStatusModal,
  setStatusFilter,
} from "../../../store/supervisorRequiredDocuments";

import { Status } from "../../../@types/status";
import { selectFilterByStatusModal } from "../../../store/supervisorRequiredDocuments/selectors/selectFilterByStatusModal";
import { closeOutline } from "ionicons/icons";
import { selectStatusFilter } from "../../../store/supervisorRequiredDocuments/selectors/selectStatusFilter";
import { fetchHojasDeCargo } from "../../../store/supervisorRequiredDocuments/actions/getHojasDeCargo";

export const FilterStatusSelector: React.FC = () => {
  const dispatch = useDispatch();

  const allStatus = [
    {
      id: 1,
      name: "Pendiente",
    },
    {
      id: 2,
      name: "Completo",
    },
    {
      id: 3,
      name: "Pendiente Firma Digital",
    },
  ];
  const statusFilter = useSelector(selectStatusFilter);
  const showModal = useSelector(selectFilterByStatusModal);

  const [statusFormData, setStatusFormData] = useState<Status[]>([]);
  const initFormData = () => {
    setStatusFormData(
      allStatus.map((statusItem) => ({
        ...statusItem,
        checked: !!statusFilter?.find(({ name }) => name === statusItem.name),
      }))
    );
  };

  const hangleCheck = (statusChecked: Status) => {
    setStatusFormData(
      statusFormData.map((statusItem) => ({
        ...statusItem,
        checked: statusChecked.name === statusItem.name ? !statusItem.checked : statusItem.checked,
      }))
    );
  };

  const applyFilter = async () => {
    dispatch(setStatusFilter(statusFormData.filter(({ checked }) => checked)));
    dispatch(setFilterByStatusModal(false));
    dispatch(fetchHojasDeCargo());
  };

  const resetStatusFilter = () => {
    dispatch(setStatusFilter([]));
    dispatch(setFilterByStatusModal(false));
    dispatch(fetchHojasDeCargo());
  };

  return (
    <>
      <IonModal
        isOpen={showModal}
        onWillPresent={initFormData}
        onDidDismiss={() => dispatch(setFilterByStatusModal(false))}
      >
        <IonHeader>
          <IonToolbar>
            <IonTitle>Filtrar por estado</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => dispatch(setFilterByStatusModal(false))}>
                <IonIcon icon={closeOutline} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonList>
            <IonListHeader>Estados</IonListHeader>
            {statusFormData.map((statusItem: Status, index: number) => (
              <IonItem key={index}>
                <IonLabel>{statusItem.name}</IonLabel>
                <IonCheckbox
                  slot="end"
                  checked={statusItem.checked}
                  onIonChange={() => hangleCheck(statusItem)}
                />
              </IonItem>
            ))}
          </IonList>
        </IonContent>
        <IonFooter>
          <IonToolbar color="light">
            <IonButtons slot="end">
              <IonButton color="danger" fill="solid" onClick={resetStatusFilter}>
                Limpiar filtro
              </IonButton>
              <IonButton color="primary" fill="solid" onClick={applyFilter}>
                Aplicar filtro
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonFooter>
      </IonModal>
    </>
  );
};
